import { BasketOverviewFormModel } from '../model/basket-overview-form.model';

export class SaveBasketOverviewFormAction {
  static type = '[BASKET] Save Overview form';

  constructor(readonly form: BasketOverviewFormModel) {}
}
